import React from 'react';
import './GlobalSearch.css';

interface FacetSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
}

export const FacetSelect: React.FC<FacetSelectProps> = ({ label, value, onChange, options }) => {
  return (
    <label className="kxd-facet-label">
      <span>{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value)} className="kxd-facet-select">
        {options.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    </label>
  );
};
